import React from "react"

/**
 * Why Visiomate — src/Design/industries/industry-*.html, SECTION 5.
 * A sticky left side (eyebrow, heading, one-line intro, "Talk to us") next
 * to a numbered list of three reasons.
 */
const WhyVisiomate = ({ eyebrow, heading, intro, linkHref, reasons = [] }) => (
  <section className="iwhy ip-block">
    <div className="iwhy__inner iwhy__split">
      <div className="iwhy__side">
        <p className="iwhy__eyebrow">{eyebrow}</p>
        <h2 className="iwhy__heading">{heading}</h2>
        <p className="iwhy__intro">{intro}</p>
        <a className="iwhy__link" href={linkHref}>
          Talk to us
        </a>
      </div>
      <div>
        {reasons.map((r, i) => (
          <div className="iwhy__reason" key={r.title}>
            <span className="iwhy__reason-n">{String(i + 1).padStart(2, "0")}</span>
            <div>
              <h3 className="iwhy__reason-title">{r.title}</h3>
              <p className="iwhy__reason-detail">{r.detail}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
)

export default WhyVisiomate
